import { render, staticRenderFns } from "./StepOneDoc.vue?vue&type=template&id=0c33eddd&scoped=true"
import script from "./StepOneDoc.vue?vue&type=script&lang=ts"
export * from "./StepOneDoc.vue?vue&type=script&lang=ts"
import style0 from "./StepOneDoc.vue?vue&type=style&index=0&id=0c33eddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33eddd",
  null
  
)

export default component.exports